<div inView (inView)="onAppear($event)" class="container section-gap">
  <div class="row">
    <div class="col-lg-6 col-sm-12 col-xs-12">
      <kla-title [position]="'left'" [lineConfig]="lineConfig" [config]="config.title" [showFooter]="false"></kla-title>
    </div>
    <div class="col-lg-6 col-sm-12 col-xs-12 chart-holder" #panel [ngStyle]="{'display': 'flex', 'align-items': 'center', 'justify-content': 'center'}">
      <div *ngIf="!configHighchart" class="row chart spinner-container">
        <div class="chart-position cm-spinner"></div>
      </div>
      <div *ngIf="configHighchart" class="row chart">
        <kla-highchart class="chart-position" [chartType]="chartType" [config]="configHighchart"
          [attr.role]="config?.chartAltText ? 'img' : null"
          [attr.aria-label]="config?.chartAltText || null"></kla-highchart>
      </div>
    </div>
    <div class="col-lg-6 col-sm-12 col-xs-12 offset-lg-6">
      <div *ngIf="config?.title?.footer" class="footer-paragraph">
        <app-dynamic-content
          [contentId]="'right-highchart-footer'"
          [htmlContent]="config.title.footer">
        </app-dynamic-content>
      </div>
    </div>
  </div>
</div>
